import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';

import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';

import { useEditItemsContext } from '../context';
import style from '../style.module.less';
import messages from '../messages';

export const AddItemButtonRow = () => {
  const { addLineItem, shouldPreventItemEdits } = useEditItemsContext();

  const onClick = useCallback(() => {
    addLineItem();
  }, [addLineItem]);

  return (
    <Button className={style['add-item-button']} disabled={shouldPreventItemEdits} onClick={onClick} theme='link'>
      <div className={style['add-item-button-contents']}>
        <FormattedMessage
          {...messages.addItemButton}
          values={{
            icon: <FontAwesomeIcon className={style.icon} icon={faPlus} />,
            span: (chunks) => <span className={style['add-item-button-text']}>{chunks}</span>,
          }}
        />
      </div>
    </Button>
  );
};
